export default __webpack_public_path__ + "static/media/img4.7bb4e02d.png";